module.exports = __webpack_public_path__ + "videos/secret-life-of-houdini.ae34f01.mp4";